<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters class="px-4 pt-2 pb-0">
      <h3 v-text="$t('servicesystem.common_objects.commonterms.list_sorting')" />
    </v-row>

    <DxSortable :data="sortings" :allow-reordering="true" item-orientation="vertical" @reorder="onListReorder">
      <v-row v-for="(sortlevel, index) in sortings" :key="sortlevel.Field" no-gutters class="my-2">
        <v-col cols="auto" class="pr-0">
          <v-btn icon class="mt-4 handle">
            <v-icon>mdi-drag-vertical</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="0">
          <QAutoComplete v-model="sortlevel.Field" :label="index === 0 ? 'First by:' : 'Then by:'"
            :list="sortablefields.filter(x => sortlevel.Field == x.Field || !sortings.find(y => y.Field == x.Field))"
            :textkey="'displayString'" :valuekey="'Field'" clearable externaledit @clear="sortings.splice(index, 1)">
          </QAutoComplete>
        </v-col>
        <v-col cols="auto" class="pl-0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small class="mt-4" v-bind="attrs" v-on="on" @click="setSortingDirection(sortlevel)">
                <v-icon v-text="sortlevel.Direction == 0 ? 'mdi-arrow-down' : 'mdi-arrow-up'">
                </v-icon>
              </v-btn>
            </template>
            <span v-text="sortlevel.Direction == 0 ? 'Desending' : 'Asending'" />
          </v-tooltip>
        </v-col>
      </v-row>
    </DxSortable>

    <v-row v-if="!hasBlank" no-gutters justify="center">
      <v-col cols="auto">
        <v-btn text color="quaternary" dark @click="addBlank()">
          <v-icon size="16" class="mr-1">mdi-plus</v-icon>
          {{ $t('servicesystem.common_objects.commonterms.add_sorting_level') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import DxSortable from "devextreme-vue/sortable";

export default {
  name: "SortingContent",
  props: {
    pk: String,
    sortablefields: Array,
    defaultsort: Array,
  },
  components: {
    DxSortable,
  },
  mixins: [],

  data() {
    return {
      sortings: [],
    };
  },

  mounted() {
    this.sortings = this.getSortingFromRoute();
  },

  methods: {
    addBlank() {
      var copy = Object.assign([], this.sortings);
      copy.push({ Field: "", Direction: 0 });
      this.sortings = copy;
    },

    onListReorder(e) {
      const list = this.sortings.splice(e.fromIndex, 1)[0];
      this.sortings.splice(e.toIndex, 0, list);
    },

    setSortingDirection(sortlevel) {
      sortlevel.Direction = sortlevel.Direction == 0 ? 1 : 0;
    },

    clone(obj) {
      return JSON.parse(JSON.stringify(obj));
    },

    getSortingFromRoute() {
      var fromparams = this.getQueryParam("filter-sorting", []);
      if (!fromparams.length) {

        return this.clone(this.defaultsort);
      }
      else {
        return this.clone(fromparams);
      }
    },

    getQueryParam(querykey, fallback) {
      var raw = this.$route.query[(this.pk ?? '') + querykey];
      return raw ? JSON.parse(raw) : fallback;
    },
    setQueryParam(querykey, update) {
      querykey = (this.pk ?? '') + querykey;
      this.$router.replace({
        query: {
          ...this.$route.query,
          [querykey]:
            update && (!Array.isArray(update) || (Array.isArray(update) && update[0]))
              ? JSON.stringify(update)
              : undefined,
        },
      });
    },
  },

  computed: {
    hasBlank() {
      if (this.sortings && this.sortings.length) {
        if (this.sortings.some((x) => x.Field === "" || x.Field === null)) {
          return true;
        } else if (this.sortings.length >= this.sortablefields.length) {
          return true;
        }
      }
      return false;
    },
  },

  watch: {
    sortings: {
      handler(newValue) {
        var setValue = newValue.filter((x) => x.Field);
        var lastVal = this.getSortingFromRoute();
        //console.log(newValue, setValue, JSON.stringify(lastVal), JSON.stringify(setValue), JSON.stringify(lastVal) !== JSON.stringify(setValue));
        if (JSON.stringify(lastVal) !== JSON.stringify(setValue)) {
          //console.log("Setting sorting");
          this.setQueryParam("filter-sorting", setValue);
        }
      },
      deep: true,
    },
  },
};
</script>
